import { LoyaltyPointsCounter } from "Components/Loyalty/LoyaltyPointsCounter";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { useIsLoyaltyPointsVisible } from "Hooks/useIsLoyaltyPointsVisible";
import { useLoyaltiesOverviewQuery } from "Api/Queries/Loyalty/useLoyaltiesOverviewQuery";
import { useIsCurrentUserHunter } from "Hooks/useIsCurrentUserHunter";
import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { LoyaltyPointType } from "Infrastructure/Api/Api";
import { appUrl } from "Utils/UrlUtils";

type Props = {
  colorVariant?: "light" | "dark";
};

export const LoyaltyPointsLink = ({ colorVariant = "dark" }: Props) => {
  const enabled = useIsLoyaltyPointsVisible();
  const { data, isLoading } = useLoyaltiesOverviewQuery({ enabled });
  const { isUserInMooneLite } = useIsUserInMooneLite();
  const isHunter = useIsCurrentUserHunter();

  if (!enabled) {
    return null;
  }

  return (
    <UnstyledLink to={appUrl(isHunter ? "valor" : "stardust")}>
      <LoyaltyPointsCounter
        isLoading={isLoading}
        colorVariant={colorVariant}
        points={data?.userPoints.points ?? 0}
        dimmed={isUserInMooneLite}
        pointsType={
          isHunter ? LoyaltyPointType.Valor : LoyaltyPointType.Stardust
        }
      />
    </UnstyledLink>
  );
};
